import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom'

import './styles/theme.css'
import './i18n'
import Cockpit from './Cockpit'
import Login from './Login'
import AuthCallback from './pages/AuthCallback'
import LoginClaim from './pages/LoginClaim'
import LoginEmail from './pages/LoginEmail'
import Packages from './pages/Packages'
import SettingsBilling from './pages/SettingsBilling'
import { Toaster } from './components/ui/toaster'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/login/email" element={<LoginEmail />} />
        <Route path="/login/claim" element={<LoginClaim />} />
        <Route path="/auth/callback" element={<AuthCallback />} />
        <Route path="/settings/billing" element={<SettingsBilling />} />
        <Route path="/packages" element={<Packages />} />
        <Route path="/" element={<Cockpit />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      <Toaster />
    </BrowserRouter>
  </React.StrictMode>,
)
